/** All react query hooks to fetch inscriptions details.
 * @module
 */

import { useMutation, QueryClient } from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';
import { BudgetPhases } from 'business/constants';
import { getMutationInformationForPhase } from 'routes/BudgetModule/shared/phases/helpers';
import { transformUrl } from 'helpers/urlHelpers';
import { snakify } from 'helpers/syntaxHelper';
import { InscriptionQueryKey } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';

export const useAddInscription = (
    onError: (error: FlowAnyObject) => void,
    onSuccess: (message: string) => void,
    queryClient: QueryClient,
    canEditInscriptions: boolean,
    phase: BudgetPhases | null,
    body:
        | { budgetLineId: number }
        | {
              budgetProposalId: number;
              expenseIncome: string;
              resourceSoftwareId: string;
          },
    cacheKey: InscriptionQueryKey,
): FlowAnyFunction => {
    const { endpoint } = getMutationInformationForPhase(
        phase,
        canEditInscriptions,
    );
    return useMutation({
        mutationFn: () =>
            RQAPICall({
                endpoint: `budget_proposals/${endpoint}`,
                body,
                method: 'POST',
                preProcessingUrlCallback: (url) =>
                    transformUrl(url, [1], snakify),
            }),

        onSuccess: (response) => {
            onSuccess(response.content.message);
            queryClient.invalidateQueries({ queryKey: cacheKey });
        },

        onError,
    });
};
